import React, { useState, useEffect } from 'react';

function PrivacyPage() {
  const [privacyPolicyText, setPrivacyPolicyText] = useState('');

  useEffect(() => {
    const fetchedPrivacyPolicy = `
      <h2><strong>1. Introduction</strong></h2>
      <p>OldMoldyCake ("we," "us," or "our") is committed to protecting the privacy of users of the BogBot Discord bot ("Bot"). This Privacy Policy explains how we collect, use, disclose, and protect your information when you use the Bot. This Privacy Policy applies only to information collected through the Bot and not to information collected offline or through other means.</p>

      <h2><strong>2. Information We Collect</strong></h2>
      <p>We collect the following types of information:</p>
      <ul>
        <li><strong>User-Provided Information:</strong>
          <ul>
            <li><strong>Chat Messages:</strong> We collect the content of chat messages in Discord channels where the Bot has been granted access, <em>excluding</em> messages in designated bot command channels. This is necessary for the Bot's AI functionality and long-term memory.</li>
            <li><strong>Usernames:</strong> We collect your Discord username.</li>
            <li><strong>User IDs:</strong> We collect Discord user IDs.</li>
            <li><strong>Server IDs:</strong> We collect the IDs of the Discord servers (guilds) where the Bot is used.</li>
          </ul>
        </li>
        <li><strong>Automatically Collected Information:</strong>
          <ul>
            <li>The Bot has information about itself such as its ID.</li>
          </ul>
        </li>
      </ul>
      <h2><strong>3. How We Use Your Information</strong></h2>
      <p>We use the information we collect for the following purposes:</p>
      <ul>
        <li><strong>Bot Functionality:</strong> To provide the Bot's core features, including AI chat responses, music playback, and other commands.</li>
        <li><strong>Long-Term Memory:</strong> To store chat history in a ChromaDB vector database, allowing the Bot to have context-aware conversations and provide more relevant responses.</li>
        <li><strong>Analytics:</strong> To analyze Bot usage patterns, identify areas for improvement, and track performance.</li>
        <li><strong>Improvement and Development:</strong> To enhance the Bot's features, develop new functionalities, and improve the user experience.</li>
      </ul>

      <h2><strong>4. Disclosure of Your Information</strong></h2>
      <p>We may disclose your information in the following circumstances:</p>
      <ul>
        <li><strong>Third-Party Service Providers:</strong>
          <ul>
            <li><strong>Google:</strong> We share chat data and prompts with Google through their APIs (Gemini and Imagen3) to enable the Bot's AI capabilities. Your use of the Bot is therefore also subject to Google's Privacy Policy.</li>
          </ul>
        </li>
        <li><strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response to a valid legal request, such as a subpoena, court order, or government investigation.</li>
        <li><strong>Protection of Rights:</strong> We may disclose your information if we believe it is necessary to protect our rights, property, or safety, or the rights, property, or safety of others.</li>
        <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, reorganization, bankruptcy, or other similar event, your information may be transferred as part of the assets of OldMoldyCake. We will strive to ensure the recipient agrees to respect this Privacy Policy.</li>
      </ul>

      <h2><strong>5. Data Security</strong></h2>
      <p>We take reasonable measures to protect your information from unauthorized access, use, or disclosure. These measures include storing data in a secure database (ChromaDB) and using secure communication protocols for API interactions. However, no method of transmission over the internet or method of electronic storage is 100% secure. Therefore, we cannot guarantee absolute security.</p>

      <h2><strong>6. Data Retention</strong></h2>
      <p>We retain your information indefinitely, or until you request deletion. If you request deletion and subsequently use the bot, your data will once again be collected.</p>

      <h2><strong>7. Your Data Rights</strong></h2>
      <ul>
          <li><strong>Access and Deletion:</strong> You have the right to request access to the data we hold about you and to request its deletion. You can make these requests through the <code>/feedback</code> command in the Bot (or a dedicated command we will implement). We will comply with your request to the extent required by applicable law. Note: Deletion will affect the functionality of the bot.</li>
          <li><strong>Rectification:</strong> If data is inaccurate you may request to have it corrected.</li>
      </ul>

      <h2><strong>8. Children's Privacy</strong></h2>
      <p>The Bot is intended for users who are at least 13 years of age, in accordance with Discord's Terms of Service. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information.</p>

      <h2><strong>9. Third-Party Links and Services</strong></h2>
       <p>The Bot interacts with third-party APIs (Google Gemini, Google Imagen3, CoinMarketCap, Discord, Spotify, YouTube). This Privacy Policy does not apply to the practices of those third parties. We encourage you to review the privacy policies of those third parties before using their services.</p>

      <h2><strong>10. Changes to This Privacy Policy</strong></h2>
      <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on the Discord server(s) where the Bot is used. You are advised to review this Privacy Policy periodically for any changes.</p>

      <h2><strong>11. Contact Us</strong></h2>
       <p>If you have any questions about this Privacy Policy, please contact us via the <code>/feedback</code> command within the Bot.</p>
    `;
    setPrivacyPolicyText(fetchedPrivacyPolicy);
  }, []);

  return (
    <div style={{ minHeight: '100vh', marginLeft: "5%", marginRight:"5%", marginTop:'3%',  }}>
      <main>
      <h1 style={{color:'white'}}><strong>Privacy Policy for Bog Bot</strong></h1>
      <p style={{paddingBottom: '5%', color:'white'}}><strong>Effective Date:</strong> 2/08/2025</p>
      <div
        style={{
          overflowY: 'auto',
          padding: '10px',
          color: 'white', 
        }}
        
        dangerouslySetInnerHTML={{ __html: privacyPolicyText }}
      />

      </main>
    </div>
  );
}

export default PrivacyPage;